document.addEventListener('DOMContentLoaded', function () {

    var domain = window.location.hostname.split('.').pop();
    var currencySymbol;
    if (domain === 'co.uk') {
        currencySymbol = '£';
    } else if (domain === 'com') {
        currencySymbol = '$';
    } else if (domain === 'eu') {
        currencySymbol = '€';
    } else {
        currencySymbol = '£';
    }

    var isSubscribeSelected = false;
    var originalTotalValue = 0;
    var isContinueClicked = false;

    function updateFooterBarVisibility() {
        var footerBar = document.getElementById('bb-footer-bar-wrap');
        if (!footerBar) return;

        var totalQuantity = 0;
        document.querySelectorAll('.bundle-builder .product-item').forEach(function (item) {
            var quantity = parseInt(item.querySelector('input[name="quantity"]').value) || 0;
            totalQuantity += quantity;
        });

        if (totalQuantity === 0) {
            footerBar.classList.add('footer-hide');
        } else {
            footerBar.classList.remove('footer-hide');
        }
    }

    function updateTotals() {
        var totalQuantity = 0;
        var totalValue = 0;

        document.querySelectorAll('.bundle-builder .product-item').forEach(function (item) {
            var quantity = parseInt(item.querySelector('input[name="quantity"]').value) || 0;
            var price = parseFloat(item.getAttribute('data-price')) || 0;

            totalQuantity += quantity;
            totalValue += quantity * price;
        });

        var fullPrice = totalValue;
        var subscriptionPrice = fullPrice * 0.9;

        document.getElementById('total-quantity').innerText = totalQuantity;

        if (isSubscribeSelected) {
            document.getElementById('total-value').innerText = `${currencySymbol}${(totalValue * 0.9).toFixed(2)}`;
        } else {
            document.getElementById('total-value').innerText = `${currencySymbol}${totalValue.toFixed(2)}`;
        }

        var subscriptionPriceOneElements = document.querySelectorAll('.bb-sub-price-one');
        subscriptionPriceOneElements.forEach(function (element) {
            element.innerText = `${currencySymbol}${fullPrice.toFixed(2)}`;
        });

        var subscriptionPriceSubElements = document.querySelectorAll('.bb-sub-price-sub');
        subscriptionPriceSubElements.forEach(function (element) {
            element.innerText = `${currencySymbol}${subscriptionPrice.toFixed(2)}`;
        });

        if (isContinueClicked) {
            showSubscriptionWidget();
            showAddToCartButton();
        } else {
            hideSubscriptionWidget();
            hideAddToCartButton();
        }

        if (totalQuantity === 0) {
            addInactiveClassToElements();
        } else {
            removeInactiveClassFromElements();
        }

        updateFooterBarVisibility();
    }

    function attachButtonListeners() {
        document.querySelectorAll('.increase-quantity, .decrease-quantity').forEach(function (button) {
            button.removeEventListener('click', updateTotals);
            button.addEventListener('click', updateTotals);
        });
    }

    attachButtonListeners();

    var subscribeRadio = document.getElementById("bb-sub-subscribe");
    subscribeRadio.addEventListener("change", function () {
        isSubscribeSelected = subscribeRadio.checked;
        updateTotals();
    });

    var oneTimeRadio = document.getElementById("bb-sub-one-time");
    oneTimeRadio.addEventListener("change", function () {
        isSubscribeSelected = !oneTimeRadio.checked;
        updateTotals();
    });

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                attachButtonListeners();
            }
        });
    });

    var config = { childList: true, subtree: true };
    observer.observe(document.querySelector('.bundle-builder'), config);

    var continueButton = document.getElementById("bb-continue");
    continueButton.addEventListener("click", function () {
        isContinueClicked = true;
        hideContinueButton();
        updateTotals();
    });

    var backButton = document.getElementById("bb-back");
    backButton.addEventListener("click", function () {
        isContinueClicked = false;
        showContinueButton();
        updateTotals();
    });

    updateTotals();

    function showSubscriptionWidget() {
        var subscriptionWidget = document.getElementById("subscription-wid-wrap");
        var sumButton = document.getElementById("bb-sum-button");
        subscriptionWidget.style.display = "flex";
        sumButton.style.display = "none";
    }

    function hideSubscriptionWidget() {
        var subscriptionWidget = document.getElementById("subscription-wid-wrap");
        var sumButton = document.getElementById("bb-sum-button");
        subscriptionWidget.style.display = "none";
        sumButton.style.display = "flex";
    }

    function hideContinueButton() {
        var continueButton = document.getElementById("bb-continue");
        continueButton.style.display = "none";
    }

    function showContinueButton() {
        var continueButton = document.getElementById("bb-continue");
        continueButton.style.display = "block";
    }

    function showAddToCartButton() {
        var addToCartButton = document.getElementById("add-to-cart");
        addToCartButton.style.display = "block";
    }

    function hideAddToCartButton() {
        var addToCartButton = document.getElementById("add-to-cart");
        addToCartButton.style.display = "none";
    }

    function addInactiveClassToElements() {
        var elementsToMakeInactive = document.querySelectorAll('#bb-sum-button, #bb-continue, #add-to-cart');
        elementsToMakeInactive.forEach(function (element) {
            element.classList.add('inactive');
        });
    }

    function removeInactiveClassFromElements() {
        var elementsToRemoveInactive = document.querySelectorAll('#bb-sum-button, #bb-continue, #add-to-cart');
        elementsToRemoveInactive.forEach(function (element) {
            element.classList.remove('inactive');
        });
    }

    $(document).on('updateQuantities', function() {
        updateTotals();
    });

});